import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSweden = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 512 512",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "circleClip",
		children: /* @__PURE__ */ _jsx("circle", {
			cx: 256,
			cy: 256,
			r: 256
		})
	}) }), /* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#circleClip)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fill: "#006aa7",
				d: "M0 0h512v512H0z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#fecc00",
				d: "M160 0h96v512h-96z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#fecc00",
				d: "M0 208h512v96H0z"
			})
		]
	})]
});
export default SvgSweden;
